module.exports = __webpack_public_path__ + "static/media/produced_x_producible.39ff4a37.svg";